import { motion } from "framer-motion";
import { Store, TrendingDown } from "lucide-react";
import ScoreBadge from "@/components/ScoreBadge";

const STATUS_LABEL = {
  new: { text: "Neu", cls: "bg-black/5 text-[#86868B]" },
  saved: { text: "Gespeichert", cls: "bg-violet-50 text-violet-600" },
  posted: { text: "Gepostet", cls: "bg-blue-50 text-blue-600" },
};

export const DealCard = ({ deal, index = 0, onClick }) => {
  const status = STATUS_LABEL[deal.status] || STATUS_LABEL.new;

  return (
    <motion.button
      type="button"
      onClick={() => onClick?.(deal)}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.4), type: "spring", stiffness: 260, damping: 22 }}
      className="group text-left bg-white rounded-2xl border border-black/5 shadow-[0_2px_10px_rgba(0,0,0,0.02)] overflow-hidden transition-all duration-300 hover:shadow-[0_10px_34px_rgba(0,0,0,0.08)] hover:-translate-y-[3px]"
      data-testid={`deal-card-${deal.id}`}
    >
      <div className="relative h-40 bg-[#F5F5F7] overflow-hidden">
        <img
          src={deal.image_url || "/wizard-icon.png"}
          alt={deal.product_name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-flex items-center gap-1 rounded-full bg-[#1D1D1F] text-white px-2.5 py-1 text-xs font-bold shadow-sm">
            <TrendingDown className="h-3 w-3" strokeWidth={2.5} />
            -{deal.discount_percent}%
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${status.cls} backdrop-blur-sm`}>
            {status.text}
          </span>
        </div>
      </div>

      <div className="p-4">
        <div className="flex items-center gap-1.5 text-xs text-[#86868B] mb-1.5">
          <Store className="h-3.5 w-3.5" strokeWidth={2} />
          {deal.source}
          <span className="mx-1 opacity-40">·</span>
          {deal.category}
        </div>
        <h3 className="font-heading font-semibold text-[15px] leading-snug text-[#1D1D1F] line-clamp-2 min-h-[40px]">
          {deal.product_name}
        </h3>

        <div className="flex items-end justify-between mt-3">
          <div>
            <p className="text-xs text-[#A1A1A6] line-through">{deal.original_price.toFixed(2)} €</p>
            <p className="font-heading text-xl font-bold text-[#1D1D1F] tracking-tight">
              {deal.deal_price.toFixed(2)} €
            </p>
          </div>
          <ScoreBadge score={deal.ai_score} />
        </div>
      </div>
    </motion.button>
  );
};

export default DealCard;
